export default __webpack_public_path__ + "static/media/gallery_02.da7fd4b8.jpg";